jQuery('.read-more.toggle').on('click', function() {
    jQuery(this).parents().children('.additional-description').slideToggle( function() {
        if(jQuery(this).is(':visible')) {
            jQuery(this).siblings('.read-more.toggle').addClass('less');
        }
        else {
            jQuery(this).siblings('.read-more.toggle').removeClass('less');
        } 
    });
});